export class HealthBar {
	x: number;
	y: number;
	maxHealth: number;
	currentHealth: number;
	heartSize: number;
	spacing: number;

	constructor(x: number, y: number, maxHealth: number = 9) {
		this.x = x;
		this.y = y;
		this.maxHealth = maxHealth;
		this.currentHealth = maxHealth;
		this.heartSize = 2; // Pixel size
		this.spacing = 20; // Space between hearts
	}

	draw(): void {
		push();

		for (let i = 0; i < this.maxHealth; i++) {
			const heartX = this.x + i * this.spacing;
			const heartY = this.y;
			const isFilled = i < this.currentHealth;

			this.drawHeart(heartX, heartY, isFilled);
		}

		pop();
	}

	private drawHeart(x: number, y: number, filled: boolean): void {
		push();
		translate(x, y);

		const p = this.heartSize; // Pixel size

		noStroke();

		if (filled) {
			// Filled heart - red with black outline
			// Row 0: outline top
			fill(0);
			rect(-3 * p, -3 * p, p, p);
			rect(-2 * p, -4 * p, p, p);
			rect(-1 * p, -4 * p, p, p);
			rect(0 * p, -3 * p, p, p);
			rect(1 * p, -4 * p, p, p);
			rect(2 * p, -4 * p, p, p);
			rect(3 * p, -3 * p, p, p);

			// Row 1: outline sides + red fill
			rect(-4 * p, -2 * p, p, p);
			rect(4 * p, -2 * p, p, p);
			fill(255, 0, 0);
			rect(-3 * p, -2 * p, 7 * p, p);

			// Row 2: outline sides + red fill
			fill(0);
			rect(-4 * p, -1 * p, p, p);
			rect(4 * p, -1 * p, p, p);
			fill(255, 0, 0);
			rect(-3 * p, -1 * p, 7 * p, p);

			// Row 3: narrowing
			fill(0);
			rect(-4 * p, 0 * p, p, p);
			rect(4 * p, 0 * p, p, p);
			fill(255, 0, 0);
			rect(-3 * p, 0 * p, 7 * p, p);

			// Row 4: narrowing more
			fill(0);
			rect(-3 * p, 1 * p, p, p);
			rect(3 * p, 1 * p, p, p);
			fill(255, 0, 0);
			rect(-2 * p, 1 * p, 5 * p, p);

			// Row 5: narrowing more
			fill(0);
			rect(-2 * p, 2 * p, p, p);
			rect(2 * p, 2 * p, p, p);
			fill(255, 0, 0);
			rect(-1 * p, 2 * p, 3 * p, p);

			// Row 6: bottom tip
			fill(0);
			rect(-1 * p, 3 * p, p, p);
			rect(1 * p, 3 * p, p, p);
			fill(255, 0, 0);
			rect(0 * p, 3 * p, p, p);

			// Row 7: bottom point
			fill(0);
			rect(0 * p, 4 * p, p, p);
		} else {
			// Empty heart - just outline (dark gray)
			fill(60);

			// Row 0: outline top
			rect(-3 * p, -3 * p, p, p);
			rect(-2 * p, -4 * p, p, p);
			rect(-1 * p, -4 * p, p, p);
			rect(0 * p, -3 * p, p, p);
			rect(1 * p, -4 * p, p, p);
			rect(2 * p, -4 * p, p, p);
			rect(3 * p, -3 * p, p, p);

			// Row 1: outline sides
			rect(-4 * p, -2 * p, p, p);
			rect(4 * p, -2 * p, p, p);

			// Row 2: outline sides
			rect(-4 * p, -1 * p, p, p);
			rect(4 * p, -1 * p, p, p);

			// Row 3: outline sides
			rect(-4 * p, 0 * p, p, p);
			rect(4 * p, 0 * p, p, p);

			// Row 4: narrowing
			rect(-3 * p, 1 * p, p, p);
			rect(3 * p, 1 * p, p, p);

			// Row 5: narrowing
			rect(-2 * p, 2 * p, p, p);
			rect(2 * p, 2 * p, p, p);

			// Row 6: bottom tip
			rect(-1 * p, 3 * p, p, p);
			rect(1 * p, 3 * p, p, p);

			// Row 7: bottom point
			rect(0 * p, 4 * p, p, p);
		}

		pop();
	}

	takeDamage(amount: number = 1): void {
		this.currentHealth = Math.max(0, this.currentHealth - amount);
	}

	heal(amount: number = 1): void {
		this.currentHealth = Math.min(this.maxHealth, this.currentHealth + amount);
	}

	reset(): void {
		this.currentHealth = this.maxHealth;
	}

	isDead(): boolean {
		return this.currentHealth <= 0;
	}
}
